"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _reactRouterDom = require("react-router-dom");
var _react = _interopRequireDefault(require("react"));
var _loginConnector = _interopRequireDefault(require("../../../../login/login-connector"));
var _link = _interopRequireDefault(require("../../../core/link"));
var _navTabs = _interopRequireDefault(require("../../../core/nav-tabs"));
var _alert = _interopRequireDefault(require("../../../core/alert"));
var _competition = _interopRequireDefault(require("./competition"));
var _administrators = _interopRequireDefault(require("./administrators"));
var _datesAndLimits = _interopRequireDefault(require("./dates-and-limits"));
var _divisions = _interopRequireDefault(require("./divisions"));
var _races = _interopRequireDefault(require("./races"));
var _startList = _interopRequireDefault(require("./start-list"));
var _notFound = _interopRequireDefault(require("../../../not-found"));
var _fullWidth = _interopRequireDefault(require("../../../root/full-width"));
var _requireAuthentication = _interopRequireDefault(require("../../../require-authentication"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
var _ref = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "danger"
}, "You must be logged in as the competition organiser to set up the competition.");
var _ref2 = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _notFound.default
});
function SetUp({
  loaded,
  competition,
  match: {
    url,
    path
  }
}) {
  if (loaded && !competition.isAdministratedByUser) {
    return _ref;
  }
  return /*#__PURE__*/_react.default.createElement(_fullWidth.default, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_navTabs.default, null, /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    "data-test-id": "setup-competition",
    className: "nav-link",
    activeClassName: "active",
    to: url + '/competition'
  }, "Competition")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    "data-test-id": "setup-administrators",
    className: "nav-link",
    activeClassName: "active",
    to: url + '/administrators'
  }, "Administrators")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    "data-test-id": "setup-dates-and-limits",
    className: "nav-link",
    activeClassName: "active",
    to: url + '/dates-and-limits'
  }, "Dates and Limits")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    "data-test-id": "setup-divisions",
    className: "nav-link",
    activeClassName: "active",
    to: url + '/divisions'
  }, "Divisions")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    "data-test-id": "setup-races",
    className: "nav-link",
    activeClassName: "active",
    to: url + '/races'
  }, "Races")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    "data-test-id": "setup-start-list",
    className: "nav-link",
    activeClassName: "active",
    to: url + '/start-list'
  }, "Start List"))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: 14
    }
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/competition',
    component: _competition.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/administrators',
    component: _administrators.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/dates-and-limits',
    component: _datesAndLimits.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/divisions',
    component: _divisions.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/races',
    component: _races.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/start-list',
    component: _startList.default
  }), _ref2))));
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref3 = {
  isAdministratedByUser: true
};
var _default = exports.default = (0, _requireAuthentication.default)((0, _reactBicycle.connect)(SetUp, props => ({
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref3
}), undefined, {
  renderLoading: true
}));